export const CIRCLE_COLORS = ['#7C6BD6', '#2E9E83', '#E2603B'];

export const OUTSIDE_COLOR = '#8A8A8A';

export const REQUIRED_ANSWERS: Record<Matches.Category, number> = {
  disciplines: 10,
  majors: 20,
  universities: 30,
};

export const CATEGORY_ORDER: Matches.Category[] = ['disciplines', 'majors', 'universities'];

export const TOP_MATCHES = 3;

export const ANSWERED_ASSERTIONS_LIMIT = 100;
